module.exports = __webpack_public_path__ + "static/tcdd-cozumler-f4ec523627efe3b8b13c414d85faf138.png";